module.exports = __webpack_public_path__ + "static/media/2.547bf241.jpg";